import { render, staticRenderFns } from "./coentent_table.vue?vue&type=template&id=420a6ebe&scoped=true&"
import script from "./coentent_table.vue?vue&type=script&lang=js&"
export * from "./coentent_table.vue?vue&type=script&lang=js&"
import style0 from "./coentent_table.vue?vue&type=style&index=0&id=420a6ebe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a6ebe",
  null
  
)

export default component.exports